<template>
    <div class="right_box_main">
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <el-row :gutter="50">
                            <el-col v-for="(item,index) in data" :span="4" :key="index">
                                <a :href="item.url" target="_blank">
                                    <el-image style="width: 100%;" :src="item.img" fit="contain"></el-image>
                                    <p>{{item.name}}</p>
                                </a>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: [
                {
                    name: "安徽省人口信息综合业务平台",
                    img: require("@/assets/images/tubiao/安徽省人口信息综合业务平台.jpg"),
                    url: "http://10.10.13.11:8000/MainUI/Main.aspx"
                },
                {
                    name: "安徽省计生协基金会信息管理系统",
                    img: require("@/assets/images/tubiao/安徽省计生协会.jpg"),
                    url: "http://220.178.116.66:9999/ "
                },
                {
                    name: "安徽省老龄信息管理系统",
                    img: require("@/assets/images/tubiao/安徽省老龄信息管理系统.jpg"),
                    url: "http://220.178.116.78:9091/?tdsourcetag=s_pcqq_aiomsg"
                },
                {
                    name: "全国残疾人两项补贴信息系统",
                    img: require("@/assets/images/tubiao/全国残疾人两项补贴信息系统.jpg"),
                    url: "https://lxbt.mca.gov.cn/cjrlb/pages/login/login.jsp"
                },
                {
                    name: "安徽阳光就业网",
                    img: require("@/assets/images/tubiao/安徽阳光就业网.jpg"),
                    url: "http://ygjy.ah.gov.cn/ww/updateAab301new.html?aab301=340405000000&NumId=1"
                },
                // {
                //     name: "淮南市人社局",
                //     img: require("@/assets/images/tubiao/淮南市人社局.jpg"),
                //     url: "http://rsj.huainan.gov.cn/"
                // },
                {
                    name: "全国征兵网",
                    img: require("@/assets/images/tubiao/全国征兵网.jpg"),
                    url: "https://www.gfbzb.gov.cn/"
                },
                {
                    name: "全国党员网",
                    img: require("@/assets/images/tubiao/共产党员网.jpg"),
                    url: "http://www.12371.cn/"
                },
                // {
                //     name: "淮南网上阳光（居）务监督平台",
                //     img: require("@/assets/images/tubiao/淮南网上阳光（居）务监督平台.jpg"),
                //     url: "http://ygcj.huainan.gov.cn/"
                // },
                {
                    name: "先锋网电子政务平台后台",
                    img: require("@/assets/images/tubiao/安徽先锋网电子政务后台管理.jpg"),
                    url: "http://newoa.ahxf.gov.cn/Account/Login/?ReturnUrl=%2fHome%2fIndex"
                },
                {
                    name: "安徽政务服务网",
                    img: require("@/assets/images/tubiao/安徽政务服务网.png"),
                    url: "https://www.ahzwfw.gov.cn/"
                },
            ]
        };
    },
    created() {},

    mounted() {}
};
</script>

<style lang="less" scoped>
.el-col {
    margin-bottom: 25px;
}
.el-col a {
    p {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    text-decoration: none;
    color: #333;
    text-align: center;
}
</style>